export default "__VITE_ASSET__CDLlSC$X__"